
import { NavBar } from "../../components";
import { useEffect } from "react";


export const Help = () => {

    useEffect(() => {
        document.title = "راهنما | دایان"
    }, [])



    return (
        <>
            <div className='w-full min-h-screen flex flex-col'>
                <NavBar title='راهنما'/>
                <div className='w-full flex flex-col items-center p-[20px]'>
                    {[1,2,3,4,5,6,7].map((item:any , index:number)=>
                        <img src={`/assetes/help/${item}.jpg`} className='max-w-[300px] w-full my-2' />
                    )}
                </div>
            </div>
        </>
    );
}